import { render } from "./EncashmentZenith.vue?vue&type=template&id=47effe7e&scoped=true&ts=true"
import script from "./EncashmentZenith.vue?vue&type=script&lang=ts"
export * from "./EncashmentZenith.vue?vue&type=script&lang=ts"

import "./EncashmentZenith.vue?vue&type=style&index=0&id=47effe7e&scoped=true&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47effe7e"]])

export default __exports__